
import { Component, Prop, Vue } from 'vue-property-decorator';
import OrderSummary from '@/components/PaymentForm/OrderSummary.vue';
import Icon from '@/components/Icons/Icon.vue';
import { mapGetters } from 'vuex';
import StripeCheckoutService from '@/Services/Subscription/StripeCheckoutService';
import { Plan } from '@/classes/stripe';
@Component({
  components: {
    OrderSummary,
    Icon,
  },
  computed: {
    ...mapGetters('subscription', ['relatedPlans']),
  },
})
export default class PaymentFormSidebar extends Vue {
  @Prop({ type: Plan })
  selectedPlan!: Plan;
  @Prop({ type: StripeCheckoutService })
  stripeCheckoutService!: StripeCheckoutService;
  @Prop({ type: String })
  checkoutType!: string;
  relatedPlans!: Array<Plan>;
  // Load selected plan (used when changing monthly/yearly)
  async loadSelectedPlan(plan: Plan): Promise<void> {
    Object.assign(this.selectedPlan, new Plan(plan));
  }
}
